module.exports = __webpack_public_path__ + "img/ico_order_minus.12302cf9.svg";